import PropTypes from 'prop-types';

export const CommunicationModel = {
    id: PropTypes.string,
    title: PropTypes.string,
    status: PropTypes.string,
    dateCreatedString: PropTypes.string,
    sentDateString: PropTypes.string,
    creatorName: PropTypes.string,
    message: PropTypes.string,
    includesPoll: PropTypes.bool,
    poll: PropTypes.shape({
        question: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.shape({
            text: PropTypes.string,
            responseCount: PropTypes.number
        })),
        noResponseCount: PropTypes.number
    }),
    recipientCount: PropTypes.number,
    emailCount: PropTypes.number,
    smsCount: PropTypes.number,
    voiceCount: PropTypes.number,
    recipients: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        displayName: PropTypes.string,
        notificationMethods: PropTypes.arrayOf(PropTypes.string),
        pollResponse: PropTypes.string,
        pollResponseDate: PropTypes.string, // for sorting - e.g., "2020-04-06T13:38:43.2711568-05:00"
        pollResponseDateString: PropTypes.string
    })),
    associatedEvent: PropTypes.shape({title: PropTypes.string}),
    availableEvents: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        type: PropTypes.string
    })),
};

export const CommunicationListModel = {
    id: PropTypes.string,
    title: PropTypes.string,
    status: PropTypes.string,
    dateCreatedString: PropTypes.string,
    sentDateString: PropTypes.string,
    recipientCount: PropTypes.number,
};
